import autoBind from 'react-autobind';
import {connect} from 'react-redux';
import {List} from 'immutable';
import {LogInForm} from '../components';
import {Page} from '../../layout/components';
import toastr from 'toastr';
import {withRouter} from 'react-router';
import {getReturnPath} from '../selectors';
import {logIn, resetLoginForm, setLoginFormField, setReturnPath} from '../actions/creators';
import React, {Component, PropTypes} from 'react';

class LogInPage extends Component {
  constructor(props, context) {
    super(props, context);

    autoBind(this);
  }

  componentWillMount() {
    this.props.resetLoginForm();
  }

  handleFieldChange(event) {
    const {name, value} = event.target;
    this.props.handleFieldChange(name, value);
  }

  handleSubmit(event) {
    event.preventDefault();

    const {handleSubmit, model, returnPath, router, setReturnPath} = this.props;

    handleSubmit(model)
      .then(response => {
        if (response.value.data.isFirstLogin) {
          router.push(`create-profile/${response.value.data.id}`);
        } else {
          setReturnPath('');
          router.push(returnPath || '/');
        }
      })
      .catch(error => {
        if (error.response && error.response.status === 401) {
          toastr.error(error.response.data, 'Error');
          return;
        }
        toastr.error('An error occurred while attempting to login.', 'Error');
      });
  }

  render() {
    const {model, submitting} = this.props;

    return (
      <Page pageClassName="log-in-page">
        <LogInForm
          model={model}
          submitting={submitting}
          onFieldChange={this.handleFieldChange}
          onSubmit={this.handleSubmit} />
      </Page>
    );
  }
}

LogInPage.propTypes = {
  handleFieldChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  model: PropTypes.object.isRequired,
  resetLoginForm: PropTypes.func.isRequired,
  returnPath: PropTypes.string,
  router: PropTypes.object.isRequired,
  setReturnPath: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
};

function mapStateToProps(state) {
  const {logIn} = state.features.authentication.pages;

  return {
    model: logIn.get('model'),
    returnPath: getReturnPath(state),
    submitting: logIn.get('submitting'),
  };
}

export default withRouter(connect(
  mapStateToProps,
  {
    resetLoginForm,
    setReturnPath,
    handleFieldChange: setLoginFormField,
    handleSubmit: logIn
  }
)(LogInPage));



// WEBPACK FOOTER //
// ./app/features/authentication/containers/LogInPage.js